The identifier of the original SEEK job application.

Only applicable to application status updates for Optimised Apply.
